// GENERAL
const frontend = 'wg3m';
export const BRDGE_PROJECT_ID = "wow_" + frontend;
// LOCALES
export const AVAILABLE_LOCALES = ["en", "de", "fr", "it", "es", "tr"];
export const CLOUDFLARE_CUSTOMER = "customer-86fwfg7ayixwen07.cloudflarestream.com"
export const DEFAULT_LOCALE = "de";
